import React from 'react';
import { GraduationCap, Flag, Zap, Wallet, QrCode, ChevronRight } from 'lucide-react';

const GREEN = '#2E6A4C';
const eur = (v) => `${Number(v || 0).toFixed(2).replace('.', ',')} €`;
const num = (v) => (Number.isInteger(Number(v)) ? String(Number(v)) : Number(v).toFixed(1).replace('.', ','));

const Tile = ({ icon: Icon, color, bg, value, label, testId, children }) => (
  <div className="rounded-xl px-3 py-2.5 flex items-center gap-2.5 min-w-0" style={{ backgroundColor: bg }} data-testid={testId}>
    <Icon size={16} style={{ color }} className="flex-shrink-0" />
    <div className="min-w-0 flex-1">
      <p className="font-black leading-tight truncate" style={{ fontSize: '15px', color }} data-testid={`${testId}-value`}>{value}</p>
      <p className="font-medium truncate" style={{ fontSize: '10px', color: '#777' }}>{label}</p>
    </div>
    {children}
  </div>
);

/* Accueil → « Mes soldes » : carnets, jetons practice (QR en un clic) et solde du compte (si activé). Rien à afficher → carte masquée. */
export const BalancesRecapCard = ({ coursHours, gfCount, practiceTokens, onShowQr, accountBalance, showAccount = true, onSeeAll, shadow }) => (
  !(coursHours > 0 || gfCount > 0 || practiceTokens > 0 || showAccount) ? null : (
  <div className="rounded-2xl px-4 py-3.5" style={{ backgroundColor: 'rgba(255,255,255,0.9)', boxShadow: shadow }} data-testid="dashboard-balances">
    <div className="flex items-center justify-between mb-2.5">
      <p className="font-bold uppercase" style={{ fontSize: '11px', color: '#999', letterSpacing: '0.08em' }}>Mes soldes</p>
      <button type="button" onClick={onSeeAll} className="font-semibold flex items-center gap-0.5" style={{ fontSize: '11px', color: GREEN }} data-testid="dashboard-balances-see-all">
        Voir tout <ChevronRight size={12} />
      </button>
    </div>
    <div className="grid grid-cols-2 gap-2">
      {coursHours > 0 && <Tile icon={GraduationCap} color="#1D4ED8" bg="#EEF2FD" value={`${num(coursHours)} h`} label="Carnet de cours" testId="balance-cours" />}
      {gfCount > 0 && <Tile icon={Flag} color={GREEN} bg="#E8F3EC" value={`${num(gfCount)} GF`} label="Carnet green fee" testId="balance-gf" />}
      {practiceTokens > 0 && (
        <Tile icon={Zap} color="#B45309" bg="#FBF1DF" value={`${Math.floor(practiceTokens)} jeton${Math.floor(practiceTokens) > 1 ? 's' : ''}`} label="Balles practice" testId="balance-practice">
          {onShowQr && (
            <button type="button" onClick={onShowQr} className="w-8 h-8 rounded-lg bg-white flex items-center justify-center flex-shrink-0 hover:scale-105 transition-transform"
              style={{ boxShadow: '0 1px 4px rgba(0,0,0,0.12)' }} aria-label="Afficher le QR code practice" data-testid="balance-practice-qr-btn">
              <QrCode size={16} style={{ color: '#B45309' }} />
            </button>
          )}
        </Tile>
      )}
      {showAccount && <Tile icon={Wallet} color={accountBalance < 0 ? '#B91C1C' : '#0F766E'} bg="#E6F4F1" value={eur(accountBalance)} label="Mon compte" testId="balance-account" />}
    </div>
  </div>
  )
);
